export default {"src":"/_next/static/media/Inbox-logo-v2.22f3ae05.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};